import React from "react";

const DonationItem = ({ donation }) => (
  <div className="p-4">
    <p className="text-sm text-slate-500">You donated to</p>
    <p className="font-bold text-slate-800">{donation.causeTitle}</p>
    <p className="text-sm text-slate-500">for {donation.creatorName}</p>
    <div className="flex justify-between items-baseline mt-2">
      <p className="text-xs text-slate-400">{donation.date}</p>
      <p className="font-semibold text-primary">{donation.amountETB} ETB</p>
    </div>
  </div>
);

export default DonationItem;
